module.exports = __webpack_public_path__ + "img/skull_6_bj.e62c1b3b.png";